export default __webpack_public_path__ + "static/media/cover_solitaire.cf9c91d5.mp4";